import React from "react";
import Button from "../Button/Button";

import "./ErrorBoundary.css";
import { ErrorBoundaryFallBack } from "../../Assets/assets";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
    this.props.handleComponentDidCatch(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="inherit-parent-height inherit-parent-width flex-place-children-page-center">
          <div className="error-fallback-image-height">
            <ErrorBoundaryFallBack />
            <div className="text-align-center font-size-medium padding-vertical-larger">
              Something's broken
            </div>
            <Button
              boxShadow={false}
              text="Take me back"
              onClick={this.props.onClick}
            />
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
